<!--
* @description  参数1
* @fileName  LoginDialog
* @author userName
* @date 2023-12-21 17:53:23
!-->
<template>
  <div id="LoginDialog" class="LoginDialog">
    <global-login-dialog
      v-if="!isForgot"
      v-model="$store.getters.loginDialogVisible"
      class="login-class"
      @close="closeDialog"
    >
      <template v-slot:title>
        <div class="title-first">Welcome back !</div>
        <div class="title-two">Shipping. Simplified.</div>
      </template>
      <template v-slot:body>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
          <el-form-item prop="account">
            <div class="left">Email adress</div>
            <el-input
              ref="account"
              v-model="loginForm.account"
              placeholder="Enter your email"
              name="account"
              type="text"
              tabindex="1"
              autocomplete="on"
              size="large"
            />
          </el-form-item>
          <el-form-item prop="password">
            <div class="left">Password</div>
            <el-input
              ref="password"
              v-model="loginForm.password"
              type="password"
              placeholder="Password"
              name="password"
              tabindex="1"
              autocomplete="on"
              size="large"
            />
          </el-form-item>
        </el-form>
        <button class="by-button--primary craetAccount" @click="login()">
          login
        </button>
      </template>
      <template v-slot:footer>
        <div class="footer-first">
          <div class="footer-first-left">
            <div
              :class="isRemenber ?'choose-icon-active':'choose-icon'"
              @click="()=>{isRemenber = !isRemenber}"
            />
            Remenber me
          </div>
          <div class="footer-first-right">
            <span @click="forgotPwd">Forgot password?</span>
          </div>
        </div>
        <div class="footer-two">
          Don't have an account? <span @click="toRegister"> Sign up</span>
        </div>
      </template>
    </global-login-dialog>
    <global-login-dialog v-model="isForgot" class="Forgot-class">
      <template v-slot:title>
        <i class="el-icon-arrow-left Forgot-black" @click="back" />
        <div class="Forgot-title-first">Forgot your password?</div>
        <div class="Forgot-title-two">
          No problem. Just enter your email address and we’ll send you a reset
          link
        </div>
      </template>
      <template v-slot:body>
        <div v-if="isSendEmail">
          <el-form ref="emailForm" :model="emailForm" :rules="emailRules">
            <el-form-item prop="email">
              <div class="left">Email adress</div>
              <el-input
                ref="email"
                v-model="emailForm.email"
                placeholder="Enter your email"
                name="email"
                type="text"
                tabindex="1"
                autocomplete="on"
                size="large"
              />
            </el-form-item>
          </el-form>
          <div class="forgot-foot">
            <button class="by-common--primary forgot-back" @click="back">Back</button>
            <button
              class="by-button--primary forgot-link"
              :disabled="isResetLoading"
              @click="GetResetLink"
            >Get reset link</button>
          </div>
        </div>
        <div v-if="isResetPwd">
          <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules">
            <el-form-item prop="password">
              <div class="left">Create new password</div>
              <el-input
                ref="account"
                v-model="passwordForm.password"
                placeholder="Create new password"
                name="account"
                show-password
                :class="{'errorTip':!isLength || !isString || !isNum || !isSymbol}"
                @input="validatePwd($event)"
              />
              <div class="error-main">
                <template v-if="!isLength || !isString || !isNum || !isSymbol">
                  <div class="error-tip"><i class="el-icon-close" />Password strength: weak</div>
                  <div v-if="!isLength" class="error-tip"><i class="el-icon-close" />At least 8
                    characters</div>
                  <div v-if="!isString" class="error-tip"><i class="el-icon-close" />Contains both
                    lower and upper case letters</div>
                  <div v-if="!isNum || !isSymbol" class="error-tip"><i
                    class="el-icon-close"
                  />Contains a number and symbol</div>
                </template>
                <template v-else>
                  <div v-if="passwordForm.password" class="success-tip"><i
                    class="el-icon-check"
                  />Password strength: strong</div>
                </template>
              </div>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <div class="left">Re-enter password</div>
              <el-input
                ref="account"
                v-model="passwordForm.confirmPassword"
                placeholder="Re-enter password"
                show-password
                :class="{'errorTip':!isItEqual}"
                @blur="onInputBlur"
              />
              <div v-if="!isItEqual" class="error-main">
                <div class="error-red">Looks like the passwords don't match. Try again?</div>
              </div>
            </el-form-item>
          </el-form>
          <div class="forgot-foot m16">
            <button class="by-button--primary forgot-link" @click="Resetpassword">Reset my password</button>
          </div>
        </div>
      </template>
    </global-login-dialog>
  </div>
</template>

<script>
import {
  login,
  SendFogetPwdEmail,
  ResetPassword,
  GetCurrCustomer
} from '../../api/user.js'
import {
  message
} from '@/utils/message'
import {
  setCookie,
  getCookie,
  delCookie
} from '@/utils/cookiejs'
import GlobalLoginDialog from '../../components/Dialog/Dialog.vue'
import md5 from 'js-md5'
export default {
  name: 'LoginDialog',
  components: {
    // 组件的引用
    GlobalLoginDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        },
        {
          pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
          message: "We don't recognize this email address. Want to try again?",
          trigger: 'blur'
        }
        ],
        password: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }]
      },
      emailForm: {
        email: ''
      },
      emailRules: {
        email: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        },
        {
          pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
          message: 'We don’t recognize this email address. Want to try again?',
          trigger: 'blur'
        }
        ]
      },
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      passwordRules: {
        password: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }],
        confirmPassword: [{
          required: true,
          trigger: 'blur',
          message: 'Required'
        }]
      },
      isForgot: false,
      isLength: true,
      isString: true,
      isNum: true,
      isSymbol: true,
      isItEqual: true,
      isResetPwd: false,
      isSendEmail: false,
      resetToken: '',
      isRemenber: true,
      isResetLoading: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    var isResetPwd = getCookie('isResetPwd')
    if (isResetPwd) {
      this.isResetPwd = true
      this.isForgot = true
      this.isSendEmail = false
      this.resetToken = getCookie('resetToken')
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    onInputBlur() {
      if (this.passwordForm.confirmPassword && this.passwordForm.confirmPassword != this.passwordForm.password) {
        this.isItEqual = false
      } else {
        this.isItEqual = true
      }
    },
    // 密码校验    //不少于8个字符，使用大小字母、数字和符号四种组合
    validatePwd(str) {
      let isOK = true
      if (str.length < 8) {
        this.isLength = false
        isOK = false
      } else {
        this.isLength = true
      }
      const regString = /[a-z]|[A-Z]/
      const regNum = /\d/
      const regSymbol = /[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]/
      // 正则
      const reg1 =
					/^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/

      // 可用 test 方法验证
      if (!regString.test(str)) {
        this.isString = false
        isOK = false
      } else {
        this.isString = true
      }
      if (!regNum.test(str)) {
        this.isNum = false
        isOK = false
      } else {
        this.isNum = true
      }
      if (!regSymbol.test(str)) {
        this.isSymbol = false
        isOK = false
      } else {
        this.isSymbol = true
      }
    },
    // 方法
    Resetpassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          ResetPassword({
            password: md5(this.passwordForm.password),
            confirmPassword: md5(this.passwordForm.confirmPassword),
            resetToken: this.resetToken
          }).then(res => {
            if (res.code === 200) {
              setCookie('token', this.resetToken)
              delCookie('resetToken')
              delCookie('isResetPwd')
              this.isResetPwd = false
              this.isForgot = false
              this.$store.commit('user/DIALOG_VISIBLE', false)
              this.$router.push({
                path: '/'
              })
              window.location.reload()
            }
          })
        }
      })
    },
    closeDialog() {
      this.$store.commit('user/DIALOG_VISIBLE', false)
    },
    login() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const param = {
            account: this.loginForm.account,
            password: md5(this.loginForm.password)
          }
          login(param).then(res => {
            if (res.code === 200) {
              if (res.data.status === 1) {
                message({
                  message: 'Login succeeded',
                  type: 'success',
                  duration: 1500
                })
                this.$store.commit('user/DIALOG_VISIBLE', false)
                setCookie('token', res.data.token)
                this.getCustomer()
                var that = this
                setTimeout(function() {
                  that.$router.replace({
                    ...that.$route,
                    query: {}
                  })

                  // 刷新页面
                  window.location.reload()
                }, 500)
              } else {
                this.$store.commit('user/DIALOG_VISIBLE', false)
                this.$store.commit('user/SUCCESS_VISIBLE', true)
                this.getCustomer()
                setCookie('token', res.data.token)
              }
            }
          })
        }
      })
    },
    getCustomer() {
      GetCurrCustomer().then(res => {
        if (res.code === 200) {
          setCookie('userInfo', JSON.stringify(res.data))
        }
      })
    },
    forgotPwd() {
      // this.$store.commit("user/DIALOG_VISIBLE", false);
      this.isForgot = true
      this.isSendEmail = true
    },
    back() {
      this.isForgot = false
    },
    GetResetLink() {
      this.$refs.emailForm.validate(valid => {
        if (valid) {
          this.isResetLoading = true
          SendFogetPwdEmail(this.emailForm.email).then(res => {
            if (res.code === 200) {
              this.isResetLoading = false
              this.closeDialog()
              this.$emit('success')
              localStorage.setItem('resetEmail', this.emailForm.email)
              setTimeout(() => {
                this.$store.commit('user/SUCCESS_VISIBLE', true)
              }, 0)
            }
          })
        }
      })
    },
    // 获取页面参数
    getQueryString(key) {
      // 创建 URLSearchParams 对象并传入当前页面的 URL
      const params = new URLSearchParams(window.location.hash.split('?')[1])

      // 通过 get() 方法获取指定参数名称的值
      return params.get(key) // 'paramName'为要获取的参数名称
    },
    toRegister() {
      this.$store.commit('user/DIALOG_VISIBLE', false)
      this.$store.commit('user/STARTED_VISIBLE', true)
    }
  }
}
</script>
<style scoped lang='scss'>
	// 选中动态颜色
	$atv-colorBR: #0046b9;
	$stroke-color-index2: #f0f0f0;

	.footer-font {
		font-size: 13px;
		font-family: D, D;
		font-weight: normal;
		color: #333333;
		margin-bottom: 8px;
	}

	.LoginDialog {
		.login-class {
			.left {
				text-align: left;
			}

			.craetAccount {
				width: 336px;
				height: 40px;
				margin-top: 8px;
			}

			.footer-first {
				display: flex;
				justify-content: space-between;
				margin-bottom: 16px;

				.footer-first-left {
					display: flex;

					.choose-icon {
						width: 16px;
						height: 16px;
						background: #FFFFFF;
						border-radius: 4px;
						border: 1px solid #CCCCCC;
						margin-right: 8px;
						box-sizing: border-box;
					}

					.choose-icon-active {
						background: url('../../assets/img/client/icon_success.png');
						background-size: 16px 16px;
						width: 16px;
						height: 16px;
						margin-right: 8px;
					}
				}
			}

			.footer-first,
			.footer-two {
				@extend .footer-font;

				span {
					color: #027ffc;
					cursor: pointer;
				}
			}

			::v-deep .dialog__wrapper {
				background-color: rgba(0, 0, 0, 0.32);
			}

			::v-deep .dialog {
				//display: flex;
				width: 384px;
				min-height: 432px;
				background: #ffffff;
				border-radius: 16px;
				padding: 0;
				box-shadow: none;
				//top: 50%;
				//margin-top: -188px;
			}

			::v-deep .dialog_all {
				box-sizing: border-box;
				width: 344px;
			}

			::v-deep .dialog__header {
				width: 384px;
				height: 88px;
				background: linear-gradient(180deg,
						rgba(233, 85, 6, 0.06) 0%,
						rgba(233, 85, 6, 0.12) 100%);
				border-radius: 16px 16px 0px 0px;
				padding: 16px 24px;

				.title-first {
					font-size: 20px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
					text-align: left;
				}

				.title-two {
					font-size: 14px;
					font-family: D, D;
					font-weight: normal;
					color: #777777;
					text-align: left;
					margin-top: 8px;
				}
			}

			::v-deep .dialog__title {
				line-height: 56px;
			}

			::v-deep .dialog__body {
				padding: 16px 24px 0;
				width: 336px;

				.el-form-item {
					margin-bottom: 12px !important;
				}
			}

			::v-deep .dialog__footer {
				width: 341px;
				padding: 16px 24px;
				text-align: left;
			}

			::v-deep .dialog__header .dialog__headerbtn {
				position: relative;
				top: -52px;
				right: -168px;
			}
		}

		.Forgot-class {
			.left {
				text-align: left;
			}

			::v-deep .dialog {
				//display: flex;
				width: 384px;
				//min-height: 296px;
				background: #ffffff;
				border-radius: 16px;
				padding: 0;
				box-shadow: none;

				//top: 50%;
				//margin-top: -188px;
				.dialog__body {
					padding: 16px 24px;
				}

				.m16 {
					margin: 16px 0;
				}

				.errorTip {
					input.el-input__inner {
						background: rgba(216, 63, 63, 0.08) !important;
						border-radius: 8px;
						border: 1px solid #EF0A0A;
						color: #EF0A0A !important;
					}
				}

				.error-main {
					text-align: left;

					.error-tip {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 17px;
						text-align: left;

						i {
							color: #D83F3F;
						}
					}

					.success-tip {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #333333;
						line-height: 17px;
						text-align: left;

						i {
							color: green;
						}
					}

					.error-red {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #D83F3F;
						line-height: 17px;
					}
				}
			}

			::v-deep .dialog_all {
				box-sizing: border-box;
				width: 344px;
			}

			::v-deep .dialog__header {
				width: 384px;
				height: 128px;
				background: linear-gradient(180deg,
						rgba(233, 85, 6, 0.06) 0%,
						rgba(233, 85, 6, 0.12) 100%);
				border-radius: 16px 16px 0px 0px;
				padding: 16px 24px;

				.Forgot-black {
					float: left;
					//margin-left: 29px;
					cursor: pointer;
				}

				.Forgot-title-first {
					font-size: 20px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
					margin-bottom: 8px;
					margin-top: 24px;
				}

				.Forgot-title-two {
					font-size: 14px;
					font-family: D, D;
					font-weight: normal;
					color: #777777;
				}
			}

			::v-deep .dialog__body {
				padding: 16px 24px 0;
				width: 100%;

				.el-form-item {
					margin-bottom: 12px !important;
				}

				.forgot-foot {
					display: flex;

					.forgot-back {
						width: 116px;
						height: 40px;
						cursor: pointer;
						margin-right: 16px;
					}

					.forgot-link {
						width: 334px;
						height: 40px;
						cursor: pointer;
					}
				}

			}
		}
	}
</style>
